import * as React from 'react';

export default (props:any) => (
    <svg viewBox='0 0 24 24' {...props}>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.54">
            <image id="ic_dashboard_black_24dp_2x" x="0" y="0" width="30" height="30"
                   xlinkHref={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAA1teXP8meAAAAIBJREFUWAntlsEKgCAQBTX6/18uuy7IUKu0hwk65MtlGQe1t9au8WaeHian6h2h2O+fNkRLICEJEQHKdUhCRIDyk374kMez7VUJpSZc5QjtcMj7EGmQyss5lNozJih0aAJmzXA5h559KLXmY/5SD8sRsiFSX0ISIgKU65CEiADlNwXmBUs0OWtkAAAAAElFTkSuQmCC'}>
            </image>
        </g>
    </svg>
)
